import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import {
  DeliveryRequestURLSubmitResult,
  DeliveryRequest,
  DeliveryRequestBatchSubmitAction,
  DeliveryRequestBatchSubmitBody,
  DeliveryRequestPages,
  DeliveryRequestSearchQuery,
  PostDeliveryRequest,
  PostDeliveryRequestDeliverySent,
  PatchDeliveryRequest,
  DeliveryRequestListItem,
  DeliveryRequestListItemSecureData,
  DeliveryRequestURLSubmitForm,
} from '@models/next/DeliveryRequest';
import { f } from '@utils/nextForms';
import { z } from 'zod';

export const deliveryRequestApis = createApiHooks('/delivery-request', [
  {
    method: 'put',
    path: '/delivery-sent/:secure_data_key',
    parameters: [
      {
        type: 'Path',
        name: 'secure_data_key',
        schema: z.string(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: PostDeliveryRequestDeliverySent,
      },
    ],
    response: z.unknown(),
  },
  {
    method: 'put',
    path: '/mail-read/:secure_data_key',
    parameters: [
      {
        type: 'Path',
        name: 'secure_data_key',
        schema: z.string(),
      },
    ],
    response: z.unknown(),
  },
  {
    method: 'get',
    path: '/secure-data/:secure_data_key',
    response: DeliveryRequestListItemSecureData,
  },
]);

export const dashboardDeliveryRequestApis = createApiHooks('/dashboard/delivery-request', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(DeliveryRequestSearchQuery),
    response: DeliveryRequestPages,
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: DeliveryRequest.shape.id,
      },
    ],
    response: DeliveryRequestListItem,
  },
  {
    method: 'get',
    path: '/submit-csv',
    parameters: [
      {
        type: 'Query',
        name: 'id',
        schema: z.number().array(),
      },
    ],
    response: f.instanceOfBlob(),
  },
  {
    method: 'put',
    path: '/',
    parameters: [
      {
        type: 'Query',
        name: 'action',
        schema: DeliveryRequestBatchSubmitAction,
      },
      {
        type: 'Query',
        name: 'id',
        schema: z.number().array(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: DeliveryRequestBatchSubmitBody,
      },
    ],
    response: z.any(),
  },
  {
    method: 'post',
    path: '/',
    parameters: [
      {
        type: 'Body',
        name: 'body',
        schema: PostDeliveryRequest,
      },
    ],
    response: z.any(),
  },
  {
    method: 'patch',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: DeliveryRequest.shape.id,
      },
      {
        type: 'Body',
        name: 'body',
        schema: PatchDeliveryRequest,
      },
    ],
    response: z.any(),
  },
]);

export const dashboardDeliveryRequestURLSubmitApis = createApiHooks('/dashboard/delivery-request', [
  {
    method: 'put',
    path: '/',
    parameters: [
      {
        type: 'Query',
        name: 'action',
        schema: z.enum(['BATCH_URL_SUBMIT']),
      },
      {
        type: 'Query',
        name: 'id',
        schema: z.number().array(),
      },
      {
        type: 'Body',
        name: 'body',
        schema: DeliveryRequestURLSubmitForm,
      },
    ],
    response: DeliveryRequestURLSubmitResult.array(),
  },
]);
